import { ShieldCheck } from 'lucide-react';

/**
 * v7.3 §48 — "POPIA Compliant by Design" trust badge.
 * Surfaces FutureXV's safeguarding architecture as a marketing differentiator
 * for SA schools, unions and parents.
 */
export default function PopiaBadge({ className = '', dataTestId = 'popia-badge' }) {
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-xl border border-[#A3FF00]/30 bg-[#A3FF00]/[0.04] px-4 py-2.5 ${className}`}
      data-testid={dataTestId}
    >
      <ShieldCheck className="w-5 h-5 text-[#A3FF00] shrink-0" strokeWidth={2} />
      <div className="leading-tight">
        <p className="text-[#A3FF00] text-[10px] font-bold tracking-[0.2em] uppercase">POPIA Compliant by Design</p>
        <p className="text-zinc-400 text-xs">No private coach-athlete messaging · Aligned with Children&rsquo;s Act 38 of 2005</p>
      </div>
    </div>
  );
}
